import React from "react";

const RichTextComponent = ({ richText }) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: richText }}
    />
  );
};

export default RichTextComponent;